const Statistic2 = () => import('@/views/main/voice/statistic/Statistic2.vue')
export default {
  path: '/main/voice/statistic2',
  name: 'Statistic2',
  component: Statistic2,
  children: []
}
